import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * 搜尋功能管理
 */
function headerSearchHandler() {
  const searchInput = document.querySelector(`[data-id="header-search-input"]`);
  const searchBtn = document.querySelector(`[data-id="header-search-btn"]`);
  const searchForm = document.querySelector(`[data-id="header-search-form"]`);

  searchCollapse()();
  function searchCollapse() {
    const collapseData = {
      isOpen: false,
    };
    return function () {
      searchBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        searchInput.classList.remove('w-0', 'p-0');
        searchInput.classList.add('w-[200px]');
        collapseData.isOpen = true;
      });

      document.addEventListener('click', (e) => {
        if (collapseData.isOpen === false) {
          return;
        }
        if (e.target !== searchBtn && e.target !== searchInput) {
          searchInput.classList.remove('w-[200px]');
          searchInput.classList.add('w-0', 'p-0');
          collapseData.isOpen = false;
        }
      });
    };
  }

  searchInput.addEventListener('keyup', (e) => {
    if (e.key === 'Enter') {
      searchForm.submit();
    }
  });
}

/**
 * 手機版 menu 管理
 */
function mobileMenuHandler() {
  const mobileMenuBtn = document.querySelector(`[data-id="mobile-menuBtn"]`);
  const mobileMenuContent = document.querySelector(
    `[data-id="mobile-menuContent"]`
  );
  const header = document.querySelector('.site-header');

  const headerType = header.dataset.type;
  const siteSvg =
    document.querySelector('#site-navigation').children[1].children;
  const shopLinkSvg = document.querySelector(`[data-id="menu-shopLink"]`)
    ?.children[0];

  const body = document.querySelector('body');

  const data = {
    isOpen: false,
  };

  mobileMenuBtn.addEventListener('click', () => {
    data.isOpen = !data.isOpen;
    // 進場
    mobileMenuContent.classList.toggle('-translate-x-full');
    header.classList.toggle('bg-black');
    body.classList.toggle('max-h-dvh');
    body.classList.toggle('overflow-hidden');

    // 更換 header 及相關 icon 樣式
    const btnSvg = mobileMenuBtn.children[0].children;

    Array.from(btnSvg).forEach((svg) => {
      const path = svg.children[0];
      if (headerType === 'dark') {
        path.classList.toggle('stroke-gray-2');
      } else {
        path.classList.toggle('stroke-white');
      }
      path.classList.toggle('stroke-primary');
    });

    header.classList.toggle('hover:bg-black');

    const toggleHeaderStyle = () => {
      if (!header.classList.contains('bg-black/80')) {
        if (shopLinkSvg) {
          shopLinkSvg.children[0].classList.toggle('fill-gray-2');
          shopLinkSvg.children[0].classList.toggle('fill-white');
        }

        siteSvg[0].classList.toggle('hidden');
        siteSvg[1].classList.toggle('hidden');
      }
    };

    switch (headerType) {
      // case "light":
      //   // header.classList.toggle("hover:bg-black/80");
      //   break;
      case 'dark':
        if (data.isOpen) {
          header.classList.remove('hover:bg-white');
        }
        toggleHeaderStyle();
        break;
    }
  });
}

function mobileMenuCollapseHandler() {
  const mobileCollapseBtn = document.querySelectorAll(
    `[data-type="mobile-collapse-btn"]`
  );
  Array.from(mobileCollapseBtn).forEach((btn, key) => {
    btn.addEventListener('click', () => {
      const btnId = btn.dataset.id;
      const contentId = btnId
        .split('-')
        .map((item) => (item === 'btn' ? 'content' : item))
        .join('-');
      const linkId = btnId
        .split('-')
        .map((item) => (item === 'btn' ? 'link' : item))
        .join('-');
      const content = document.querySelector(`[data-id="${contentId}"]`);
      const link = document.querySelector(`[data-id="${linkId}"]`);

      content.classList.toggle('grid-rows-0');
      content.classList.toggle('grid-rows-1');

      link.classList.toggle('text-primary');

      const svgOpen = btn.children[0];
      const svgClose = btn.children[1];
      svgOpen.classList.toggle('opacity-0');
      svgOpen.classList.toggle('hidden');
      svgClose.classList.toggle('opacity-0');
      svgClose.classList.toggle('hidden');
    });
  });
}

/**
 * menu gsap 下滑更換樣式
 */
function menuScrollChange() {
  const body = document.querySelector('body');
  const siteHeader = document.querySelector('.site-header');
  const headerType = siteHeader.dataset.type;

  const siteSvg =
    document.querySelector('#site-navigation').children[1].children;
  const shopLinkSvg = document.querySelector(`[data-id="menu-shopLink"]`)
    ?.children[0];

  const headerSearchSvg = document.querySelector(
    `[data-id="header-search-btn"]`
  ).children[0];

  const mobileMenuBtnSvg = document.querySelector(`[data-id="mobile-menuBtn"]`)
    .children[0].children;
  const menuLinks = document.querySelectorAll('.menu-item a');

  gsap.registerPlugin(ScrollTrigger);

  const changeMenuStyle = () => {
    if (headerType === 'dark') {
      siteSvg[0].classList.toggle('hidden');
      siteSvg[1].classList.toggle('hidden');

      const screenWidth = window.innerWidth;

      if (screenWidth >= 768) {
        menuLinks.forEach((link) => {
          link.classList.toggle('text-white');
        });
      }
      headerSearchSvg.children[0].classList.toggle('fill-gray-2');
      headerSearchSvg.children[0].classList.toggle('fill-white');
      if (shopLinkSvg) {
        shopLinkSvg.children[0].classList.toggle('fill-gray-2');
        shopLinkSvg.children[0].classList.toggle('fill-white');
      }
      Array.from(mobileMenuBtnSvg).forEach((svg) => {
        svg.children[0].classList.toggle('stroke-gray-2');
        svg.children[0].classList.toggle('stroke-white');
      });
    } else {
      siteHeader.classList.toggle('hover:bg-black');
    }
  };

  const menuScroll = ScrollTrigger.create({
    trigger: body,
    start: '3% top',
    end: 'bottom top',
    scrub: true,
    // markers: true,
    // start 觸發點 向下滾動進入start點時觸發 callback
    onEnter: function () {
      siteHeader.classList.add('bg-black');
      changeMenuStyle();
    },
    //start 觸發點 向上滾動進入start點時觸發callback
    onLeaveBack: function () {
      siteHeader.classList.remove('bg-black');
      changeMenuStyle();
    },
  });
}

export {
  headerSearchHandler,
  mobileMenuHandler,
  menuScrollChange,
  mobileMenuCollapseHandler,
};
